import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Skeleton } from "@/components/ui/skeleton";

const CATEGORIES = [
  ["all", "All"], ["gateway", "AI Gateway"], ["pii", "PII Reveals"],
  ["payroll", "Payroll"], ["reviews", "Reviews"],
];

const CAT_CHIP = {
  gateway: "bg-[var(--brand-primary)] text-white",
  pii: "bg-amber-500 text-white",
  payroll: "bg-teal-600 text-white",
  reviews: "border border-teal-600 text-teal-700",
};

export const AuditTimeline = () => {
  const [category, setCategory] = useState("all");
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(null);
    api.get("/security/timeline", { params: { category, limit: 100 } }).then((r) => setData(r.data));
  }, [category]);

  return (
    <div className="space-y-4" data-testid="audit-timeline">
      <div className="flex items-center gap-2">
        {CATEGORIES.map(([v, l]) => (
          <button key={v} data-testid={`timeline-cat-${v}`} onClick={() => setCategory(v)}
            className={`text-[11px] uppercase tracking-wider px-3 py-1.5 border ${category === v ? "bg-[var(--brand-primary)] text-white border-[var(--brand-primary)]" : "bg-white text-slate-600 border-border"}`}>
            {l}
          </button>
        ))}
        {data && <span className="text-[11px] font-mono text-muted-foreground ml-auto">{data.count} events</span>}
      </div>

      {!data ? <Skeleton className="h-80 w-full rounded-none" /> : (
        <div className="bg-white border border-border overflow-x-auto">
          <table className="w-full text-[12px] min-w-[860px]">
            <thead>
              <tr className="text-left text-[10px] uppercase tracking-wider text-muted-foreground border-b border-border bg-slate-50">
                {["Timestamp (UTC)", "Category", "Type", "Event", "Masked", "Status"].map((h) => (
                  <th key={h} className="px-4 py-2.5 font-semibold">{h}</th>))}
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {data.events.map((e, i) => (
                <tr key={i} data-testid={`timeline-row-${i}`}>
                  <td className="px-4 py-2.5 font-mono text-slate-500 whitespace-nowrap">
                    {String(e.timestamp).slice(0, 19).replace("T", " ")}
                  </td>
                  <td className="px-4 py-2.5">
                    <span className={`text-[9px] font-mono px-1.5 py-0.5 uppercase ${CAT_CHIP[e.category]}`}>{e.category}</span>
                  </td>
                  <td className="px-4 py-2.5 font-mono text-[11px] text-slate-600 whitespace-nowrap">{e.type}</td>
                  <td className="px-4 py-2.5 text-slate-700 max-w-[380px]">
                    <p className="truncate" title={e.title}>{e.title}</p>
                  </td>
                  <td className="px-4 py-2.5 font-mono text-slate-500">{e.entities_masked || "—"}</td>
                  <td className="px-4 py-2.5">
                    <span className={`text-[9px] font-mono px-1.5 py-0.5 ${e.success ? "bg-teal-600 text-white" : "bg-red-600 text-white"}`}>
                      {e.success ? "OK" : "FAIL"}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AuditTimeline;
